<template>

    <transition :name="transitionName" @after-enter="afterAniamtion">
        <form :data-vv-scope="validatorScope"
              v-show="isActive && visible"
              class="c-tabs_tab">
            <div
                class="c-tabs_tab__inner"
                :class="{'c-tabs_tab__inner--narrow' : narrow}">
                <h3 v-show="title" class="c-tabs_tab-title">{{ title }}</h3>
                <slot></slot>
                <form-row
                    align="between"
                    class="c-tabs_tab__btns"
                    :class="{ 'c-tabs_tab__btns--shown':  allSectionsSaved || tabSections.length === 0 }">
                    <v-btn
                        v-show="nextBtn"
                        @click="nextTab"
                        type="next">
                        {{ nextBtn }}
                    </v-btn>
                    <v-btn
                        v-if="!this.$parent.endBtnLabel"
                        v-show="!isNext"
                        @click="saveForm"
                        type="green"
                        has-loader
                        :class="{ 'c-btn--loading' : this.$parent.isLoading }">
                        Zapisz
                    </v-btn>
                    <span v-else></span>
                    <v-btn
                        v-show="prevBtn"
                        @click="prevTab"
                        type="prev">
                        {{ prevBtn }}
                    </v-btn>
                </form-row>
            </div>
        </form>
    </transition>

</template>


<script>

import {FormRow} from 'Components/Form'
import VBtn from 'Components/VBtn'
import zenscroll from 'zenscroll'

export default {

    name: 'TabsItem',

    props: {
        title: String,
        disabled: Boolean,
        narrow: Boolean,
        visible: {
            type: Boolean,
            default: true
        },
        completed: Boolean
    },

    data() {
        return {
            isActive: false,
            isCompleted: false,
            transitionName: null,
            smoothScroll: null,
            tabSections: []
        }
    },

    computed: {
        index() {
            return this.$parent.tabItems.indexOf(this)
        },
        isNext() {
            var len = this.$parent.tabItems.length
            return ((this.index + 1) < len)
        },
        isPrev() {
            return (this.index > 0)
        },
        nextBtn() {
            if (this.isNext) {
                if (this.$parent.specificNav)
                    return 'Przejdź do ' + this.$parent.tabItems[this.index + 1].title
                else
                    return 'Następny krok'
            }
            return null
        },
        prevBtn() {
            if (this.isPrev) {
                if (this.$parent.specificNav)
                    return 'Wróć do ' + this.$parent.tabItems[this.index - 1].title
                else
                    return 'Powrót'
            }
            return null
        },
        validatorScope() {
            return 'tab-' + this.index
        },
        hasErrors() {
            return this.errors.items.filter((error) => {
                return (error.scope === this.validatorScope)
            }).length > 0
        },
        allSectionsSaved() {
            if (this.tabSections.length === 0)
                return false
            return this.tabSections.filter((sec) => {
                return sec.saved === false
            }).length === 0
        },
        hasEmpty() {
            if (this.tabSections.length === 0)
                return false
            return this.tabSections.filter((sec) => {
                return sec.saved && sec.empty
            }).length > 0
        }
    },

    methods: {
        activate(oldIndex, index) {
            this.transitionName = (index < oldIndex) ? 'slide-next' : 'slide-prev'
            this.isActive = true

        },
        deactivate(oldIndex, index) {
            this.transitionName = (index < oldIndex) ? 'slide-next' : 'slide-prev'
            this.isActive = false
        },
        afterAniamtion() {
            if (window.innerWidth < 1200)
                this.scrollTop()
        },
        checkValid() {
            return this.$parent.validator.validateAll(this.validatorScope)
        },
        prevTab() {
            this.$parent.changeTab(this.index - 1)
        },
        nextTab() {
            this.checkValid().then((isValid) => {
                if (isValid) {
                    this.isCompleted = true
                    this.$parent.changeTab(this.index + 1)
                } else {
                    this.isCompleted = false
                }
            })
        },
        saveForm() {
            this.checkValid().then((isValid) => {
                if (isValid)
                    this.$parent.saveForm()
            })
        },
        scrollTop() {
            const offset = document.getElementById('dashboard-navbar').offsetHeight
            const containerScroll = document.getElementById('dashboard-scroll').scrollTop
            const elPos = document.getElementById('tab-container').getBoundingClientRect().top
            const scrollY = elPos + containerScroll - offset
            this.smoothScroll.toY(scrollY)
        },
        scrollToSection(n) {
            if (window.innerWidth < 1200) {
                const offset = document.getElementById('dashboard-navbar').offsetHeight
                const containerScroll = document.getElementById('dashboard-scroll').scrollTop
                const elPos = this.tabSections[n].$el.getBoundingClientRect().top
                const scrollY = elPos + containerScroll - offset
                this.smoothScroll.toY(scrollY - 15)
            } else {
                this.smoothScroll.to(this.tabSections[n].$el)
            }
        },
        navigateToSection(n) {
            this.activateSectionsTo(n)
            this.tabSections[n].scrollToMe()
        },
        activateSectionsTo(n) {
            for (let i = 0; i <= n; i++)
                this.tabSections[i].isActive = true
        }
    },

    created() {
        this.$parent.tabItems.push(this)
    },

    mounted() {
        if (this.tabSections.length) {
            const len = this.tabSections.length
            let activateAll = false

            for (let i = len - 1; i >= 0; i--) {
                if (this.tabSections[i].isActive && i < len - 1 && !activateAll) {

                    this.tabSections[i + 1].isActive = true
                    activateAll = true
                }

                if (activateAll || i === 0)
                    this.tabSections[i].isActive = true
            }
        }

        if (window.innerWidth < 1200) {
            const el = document.getElementById('dashboard-scroll')
            this.smoothScroll = zenscroll.createScroller(el, 300)
        } else
            this.smoothScroll = zenscroll.createScroller(this.$el, 300)
    },

    beforeDestroy() {
        this.$parent.tabItems.splice(this.index, 1)
    },

    components: {
        FormRow,
        VBtn
    }

}

</script>

<style lang="scss">

@import '~Style/_utils.scss';

.c-tabs_tab {
    display: flex;
    flex-direction: column;
    padding: 50px;
    width: 100%;
    height: 100%;
    overflow: auto;

    @include bp($screen-sm) {
        padding: 20px;
    }
    &-title {
        width: 100%;
    }
    &__btns {
        transition: opacity .3s .5s ease-in-out;
        opacity: 0;
        pointer-events: none;

        &--shown {
            pointer-events: auto;
            opacity: 1;
        }
    }
    &__inner {
        width: 100%;
        max-width: 1000px;

        &--narrow {
            max-width: 530px;
        }
        //Animations
    }
}
.slide-next-enter-active,
.slide-next-leave-active,
.slide-prev-enter-active,
.slide-prev-leave-active {
    transition: transform, opacity;
    transition-duration: .25s;
    transition-timing-function: cubic-bezier(.32, .14, .25, 1);
}
.slide-prev-leave-to,
.slide-next-enter {
    transform: translate3d(0, -150px, 0);
    position: absolute;
    top: 0;
    width: 100%;
    opacity: 0;
}
.slide-prev-enter,
.slide-next-leave-to {
    transform: translate3d(0, 150px, 0);
    position: absolute;
    top: 0;
    width: 100%;
    opacity: 0;
}

</style>
